import type { AttachmentPickers, ComposeRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { propsBaseGlobal } from './ribbonDefinitionProps';

export type ComposePropsCache = {
    composePropsGlobal: ComposeRibbonControlDefProps | undefined;
    prevAttachmentPickers: AttachmentPickers | undefined;
    prevViewState: ComposeViewState | undefined;
};

/**
 * Returns the cached ComposeRibbonControlDefProps, rebuilding it only when any of
 * attachmentPickers, viewState, or mailboxInfo have changed reference.
 * Callers must create their own ComposePropsCache instance so SLR and MLR remain independent.
 */
export function getOrUpdateComposeProps(
    cache: ComposePropsCache,
    viewState: ComposeViewState,
    attachmentPickers: AttachmentPickers
): ComposeRibbonControlDefProps {
    if (
        !cache.composePropsGlobal ||
        !cache.prevAttachmentPickers ||
        cache.prevAttachmentPickers !== attachmentPickers ||
        !cache.prevViewState ||
        cache.prevViewState !== viewState ||
        cache.composePropsGlobal.mailboxInfo !== viewState.mailboxInfo
    ) {
        cache.prevAttachmentPickers = attachmentPickers;
        cache.prevViewState = viewState;
        cache.composePropsGlobal = {
            ...propsBaseGlobal,
            composeViewState: viewState,
            attachmentPickers,
            mailboxInfo: viewState.mailboxInfo,
        };
    }
    return cache.composePropsGlobal;
}
